var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-container"},_vm._l((_vm.digits),function(digit){return _c('counter',{key:_vm.name + '_' + (digit),ref:'counter' + _vm.name +'_' + (digit),refInFor:true,attrs:{"id":_vm.name + '_' + (digit),"small":_vm.small}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b71820","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CounterContainer.vue
// module id = null
// module chunks = 